import { defineMessages } from 'react-intl';

export const paymentMessages = defineMessages({
    paymentSelectLabel: {
        id: 'payment.paymentSelectLabel',
        description: 'Label for the payment method select',
        defaultMessage: 'Select Payment Method'
    },

    paymentType: {
        id: 'payment.paymentType',
        description: 'Payment type text',
        defaultMessage: 'Payment type'
    },

    paymentWithPoints: {
        id: 'payment.paymentWithPoints',
        description: 'Pay with points text',
        defaultMessage: 'Pay With Points'
    },

    paymentWithCreditCard: {
        id: 'payment.paymentWithCreditCard',
        description: 'Pay with credit card text',
        defaultMessage: 'Credit/Debit Card'
    },

    paymentWithSamsungPay: {
        id: 'payment.paymentWithSamsungPay',
        description: 'Payment with Samsung Pay text',
        defaultMessage: 'Samsung Pay'
    },
});
